import { useContext } from 'react';
import { CreateOwnerContractContext } from '@/contexts';

export const useCreateOwnerContractContext = () => {
  const context = useContext(CreateOwnerContractContext);

  if (!context) {
    throw new Error(
      'useCreateOwnerContractContext must be used within an CreateOwnerContractContextProvider',
    );
  }

  return context;
};

